








import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Card from '@/stories/utils/card.vue'
import UiNotFound from '@/components/ui/ui-not-found.vue';


@Component({
  components: {
    Card,
    UiNotFound,
  }
})
export default class StorybookNotFound extends Vue {}
